import { loadStripe } from '@stripe/stripe-js';

// Stripe publishable key from environment
const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// Lazy load Stripe to avoid blocking
export const stripePromise = stripePublishableKey
  ? loadStripe(stripePublishableKey)
  : null;

export function isStripeEnabled(): boolean {
  return !!stripePublishableKey;
}
